var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.386C0 3.902 0.345 3.509 0.771 3.509H3.436C3.965 3.493 4.432 3.11 4.612 2.544L4.642 2.444L4.757 2.053C4.827 1.813 4.888 1.603 4.974 1.416C5.312 0.677 5.938 0.164 6.661 0.033C6.845 -7.45058e-09 7.039 0 7.261 0H10.739C10.962 0 11.156 -7.45058e-09 11.339 0.033C12.062 0.164 12.689 0.677 13.026 1.416C13.112 1.603 13.173 1.812 13.244 2.053L13.358 2.444L13.388 2.544C13.568 3.11 14.128 3.494 14.658 3.509H17.228C17.655 3.509 18 3.902 18 4.386C18 4.87 17.655 5.263 17.229 5.263H0.77C0.345 5.263 0 4.87 0 4.386Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42474 9.48245C6.83774 9.43845 7.20474 9.75544 7.24574 10.1894L7.74574 15.4524C7.78674 15.8854 7.48574 16.2724 7.07474 16.3164C6.66274 16.3594 6.29474 16.0434 6.25374 15.6094L5.75374 10.3464C5.71274 9.91244 6.01374 9.52545 6.42474 9.48245ZM11.5747 9.48245C11.9867 9.52545 12.2877 9.91244 12.2457 10.3464L11.7457 15.6094C11.7057 16.0434 11.3377 16.3594 10.9257 16.3164C10.5127 16.2724 10.2127 15.8864 10.2537 15.4524L10.7537 10.1884C10.7947 9.75544 11.1627 9.43844 11.5737 9.48144L11.5747 9.48245Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.59622 20.0004H9.40422C12.1872 20.0004 13.5782 20.0004 14.4842 19.1144C15.3882 18.2284 15.4802 16.7754 15.6652 13.8694L15.9322 9.68141C16.0322 8.10441 16.0822 7.31541 15.6292 6.81641C15.1752 6.31641 14.4092 6.31641 12.8762 6.31641H5.12422C3.59122 6.31641 2.82422 6.31641 2.37122 6.81641C1.91722 7.31641 1.96722 8.10441 2.06822 9.68141L2.33522 13.8694C2.52022 16.7754 2.61222 18.2294 3.51722 19.1144C4.42222 20.0004 5.81322 20.0004 8.59622 20.0004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.ea0b947898beade8464e322d828f1e21.svg";
export { ForwardRef as ReactComponent };